import { mapSkuToFormValues } from '../../utils/sku';
import { emptySkuCard, regroupToFormShape, toSkuCard } from './payload';
import { ProductSkusFormValues, SelectedSKU, SkuCardValues } from './types';

export type CloneScope = 'product' | 'skus' | 'hierarchy';

const cloneScopes: CloneScope[] = ['product', 'skus', 'hierarchy'];

export const cloneScopeOf = (value: string | null): CloneScope | null =>
  cloneScopes.find((scope) => scope === value) ?? null;

const cloneSkuCard = (
  selected: SelectedSKU,
  isKeepingPallets: boolean
): SkuCardValues => {
  const card = toSkuCard(mapSkuToFormValues(selected, true));
  return isKeepingPallets ? card : { ...card, palletising: [] };
};

export const buildCloneFormValues = (
  source: SelectedSKU,
  productSkus: SelectedSKU[],
  scope: CloneScope
): ProductSkusFormValues => {
  const product = regroupToFormShape(mapSkuToFormValues(source, true));
  if (scope === 'product') return { ...product, skus: [emptySkuCard()] };

  const skusToClone = productSkus.length > 0 ? productSkus : [source];
  return {
    ...product,
    skus: skusToClone.map((sku) => cloneSkuCard(sku, scope === 'hierarchy')),
  };
};

const comparableProductId = (value?: string | null): string =>
  (value ?? '').trim().toLowerCase();

export const hasNewProductId = (
  sourceProductId: string | null | undefined,
  productId: string | null | undefined
): boolean => {
  const enteredProductId = comparableProductId(productId);
  if (enteredProductId === '') return false;
  return enteredProductId !== comparableProductId(sourceProductId);
};

export const cloneHeaderFor = (scope: CloneScope): string => {
  if (scope === 'skus') return 'Clone product & SKUs';
  if (scope === 'hierarchy') return 'Clone product hierarchy';
  return 'Clone product';
};
